import API from '@/network/API'
import { CustomSuccessData } from 'axios'
import AccountLoginInformation from '@/utils/account-manager/models/AccountLoginInformation'

const url = '/app/refresh_token'

export default function (refreshToken: string): Promise<CustomSuccessData<AccountLoginInformation>> {
  return API.instance().get<AccountLoginInformation>(url, { refresh_token: refreshToken }, { isAuthorization: false })
}
